import { motion } from "framer-motion";

export default function PageHeader({ overline, title, subtitle }) {
  return (
    <section className="relative overflow-hidden border-b border-white/10">
      <div className="absolute -top-40 -right-32 h-96 w-96 rounded-full bg-[color:var(--mc-primary)]/30 blur-3xl pointer-events-none" />
      <div className="absolute -bottom-40 -left-32 h-96 w-96 rounded-full bg-[color:var(--mc-cyan)]/15 blur-3xl pointer-events-none" />
      <div className="max-w-7xl mx-auto px-6 lg:px-10 py-24 lg:py-32 relative">
        {overline && (
          <motion.p
            initial={{ opacity: 0, y: 10 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.5 }}
            className="overline text-[color:var(--mc-gold)]"
          >
            {overline}
          </motion.p>
        )}
        <motion.h1
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.08 }}
          className="font-serif-display text-4xl sm:text-5xl lg:text-6xl font-semibold tracking-tight mt-4 max-w-3xl leading-[1.05] text-white"
        >
          {title}
        </motion.h1>
        {subtitle && (
          <motion.p
            initial={{ opacity: 0, y: 20 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.6, delay: 0.16 }}
            className="mt-6 text-lg text-white/70 max-w-2xl leading-relaxed"
          >
            {subtitle}
          </motion.p>
        )}
      </div>
    </section>
  );
}
